import React, {useCallback, useState} from 'react';
import {Stack} from '@mui/material';
import ReferenceAnalysisActions from './referenceAnalysis/ReferenceAnalysisActions';
import StatementsList from './referenceAnalysis/StatementsList';

/**
 * Reference Analysis View - combines the analysis trigger with the statements list
 */
const ReferenceAnalysisView = ({viewConfig}) => {
    const [statements, setStatements] = useState([]);

    const handleStatementsFound = useCallback((newStatements) => {
        setStatements(newStatements);
    }, []);

    const handleStatementsChange = useCallback((newStatements) => {
        setStatements(newStatements);
    }, []);

    return (
        <Stack height="100%" overflow="hidden">
            {/* Analysis trigger button */}
            <ReferenceAnalysisActions onStatementsFound={handleStatementsFound}/>

            {/* Statements list */}
            <Stack flexGrow={1} overflow="auto">
                <StatementsList
                    statements={statements}
                    onStatementsChange={handleStatementsChange}
                />
            </Stack>
        </Stack>
    );
};

export default ReferenceAnalysisView;
